module.exports = __webpack_public_path__ + "static/media/study 201114.160d3911.png";